export default __webpack_public_path__ + "static/media/skill-influence.1e9533d4.svg";